import { FC } from 'react';
import Link from 'next/link';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { DEV_ABSOLUTE_URL, slickSliderConfig } from '@/helpers/variables';
import { IAdvertisingBlock } from '@/interfaces/advertisingBlock';
import { displayNoneImgOnError } from '@/helpers/helpers';
import { PARTNER_BOOKS_LFROM } from '@/helpers/variables';
import styles from './SlickSlider.module.scss';

interface ISlickSliderPartner {
  books: IAdvertisingBlock;
}

const SlickSliderPartner: FC<ISlickSliderPartner> = ({ books }) => {
  const sortBooksData = (arr: IAdvertisingBlock) =>
    arr.sort((a, b) => {
      return a.position - b.position;
    });

  return (
    <div className={styles.booksSlider}>
      <div className={styles.booksSlider__wrap}>
        <Slider {...slickSliderConfig}>
          {sortBooksData(books).map((book) => {
            const { title, litres_url, external_id } = book;
            const bookUrl = `${litres_url}?lfrom=${PARTNER_BOOKS_LFROM}`;

            return (
              <div key={book.id} className={styles.booksSlider__item}>
                <div className={styles.booksSlider__cover}>
                  <Link target="_blank`" href={bookUrl} title={`Скачать книгу ${title}`}>
                    <img loading="lazy" src={`${DEV_ABSOLUTE_URL}/covers_185/${external_id}.jpg`} height="256" width="180" alt="slide" onError={displayNoneImgOnError} />
                  </Link>
                </div>
                <div className={styles.booksSlider__name}>
                  <Link target="_blank" href={bookUrl}>
                    {book.title}
                  </Link>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default SlickSliderPartner;
